import Vue from 'vue'
import App from './App.vue'
import router  from './router'
import store from './store'
import './plugins/element.js'
import utils from './utils/util.js'
import '@/permission' 


import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// / 分页组件
import Pagination from './components/Pagination'
Vue.component('Pagination', Pagination)

// 时间组件
import datapicker from './components/datapicker'
Vue.component('datapicker', datapicker)
import datatime from './components/datatime'
Vue.component('datatime', datatime)

import uploadone from './components/uploadone'
Vue.component('uploadone', uploadone)

import methodsMixin from './utils/methodsMixin';
Vue.mixin(methodsMixin);

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.use(VueQuillEditor);
Vue.prototype.web = utils

import './element.css'


// 过滤器
import * as custom from './utils/util'
// import { getUserMenu } from './api/pemission'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// const originalPush = router.prototype.push;
// router.prototype.push = function push(location) { return originalPush.call(this, location).catch((err) => err) }


Vue.config.productionTip = false

new Vue({
  router,
  store,
  data:{
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
},
  render: h => h(App)
}).$mount('#app')
